import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker/models';
import { AddreimbursetypepopupComponent } from '../../generalpopup/addreimbursetypepopup/addreimbursetypepopup.component';
import { ApprovepopComponent } from '../../grid/approvepop/approvepop.component';
import { ComponentCanDeactivate } from '../../PendingChangesGuard ';
import { HostListener } from '@angular/core';
import { TranspaymentinfoComponent } from '../../grid/transpaymentinfo/transpaymentinfo.component';
import { AttachmentComponent } from '../../grid/attachment/attachment.component';
import { AddexpensetypepopupComponent } from '../../generalpopup/addexpensetypepopup/addexpensetypepopup.component';
import { ActivitypopupComponent } from '../../grid/activitypopup/activitypopup.component';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';

@Component({
  selector: 'app-addreimburse',
  templateUrl: './addreimburse.component.html',
  styleUrls: ['./addreimburse.component.css']
})
export class AddreimburseComponent implements OnInit, ComponentCanDeactivate {
  @ViewChild('approvebar', { static: false }) approvebar;
  @ViewChild('attachmentbar', { static: false }) attachmentbar;

  formname: string = "REIMBURSE";
  //Display
  formmode: string = "Add";
  rtnform: string = "";

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;
  isapprovemode: boolean = false;
  isrejectmode: boolean = false;
  ispaymentmode: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;

  isshowattachment: boolean = false;
  attachmentcount: number = 0;

  isshowapproval: boolean = false;

  isapprove: boolean = false;
  isreject: boolean = false;

  ismanualclose: boolean;

  isemploading: boolean=false;

  //Filter
  filterstatus: string = "ALL";
  filteremployeeid: any = null;
  filteremployeename: any = null;
  filterfromdate: any = null;
  filtertodate: any = null;
  filterreimbursetypeid: any = null;
  filterreimbursetypename: any = null;
  filterpaymentstatus: string = "";

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;
  //Edit Get Values
  reimburseColl: any = [];
  reimburseid: number = 0
  reimburseBO: any = {}
 
  isexpensetypeaddmode: boolean = false;

  reimbursetypeColl: any = [];
  expensetypeColl: any = [];
  empColl: any = [];
  empBO: any = {};

  checkfeildmsg:any=""

  reimburseform = new FormGroup({
    reimburseid: new FormControl(0),
    empid: new FormControl(null, Validators.required),
    reimbursetypeid: new FormControl(null),
    amount: new FormControl(null, Validators.required),
    transdt: new FormControl(null, Validators.required),
    descr: new FormControl(''),
    inactive: new FormControl(false),
    isaffectpayroll: new FormControl(false),
    effectivedt: new FormControl(null, Validators.required),
    expensetypeid: new FormControl(null, Validators.required),
  });

  dateCustomClasses: DatepickerDateCustomClasses[];

  constructor(private appService: AppdataService, private loginService: LoginserviceService, private route: ActivatedRoute,
    public router: Router, private toastr: ToastrService, private productFindService: NgbModal,private confirmationDialogService: ConfirmationDialogService, 
     private datePipe: DatePipe) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.reimburseid = params.id
      }
      if (params.rtnform !== undefined) {
        this.rtnform = params.rtnform
      }

    });
    this.fnGetParameterVariable();
    this.fnServiceChanges();

    this.dateCustomClasses = [
      { date: new Date(), classes: ['bg-warning'] },
    ];
  }

  //Get Para
  fnGetParameterVariable() {
    this.route.queryParams.subscribe(params => {
      if (params.empid !== undefined) {
        this.filteremployeeid = params.empid
      }

      if (params.empname !== undefined) {
        this.filteremployeename = params.empname
      }

      if (params.status !== undefined) {
        this.filterstatus = params.status
      }

      if (params.fromdate !== undefined) {
        this.filterfromdate = this.fnConvertDatetime(this.fnFormatDatetime(params.fromdate))
      }

      if (params.todate !== undefined) {
        this.filtertodate = this.fnConvertDatetime(this.fnFormatDatetime(params.todate))
      }
      if (params.reimbursetypeid !== undefined) {
        this.filterreimbursetypeid = params.reimbursetypeid
      }

      if (params.reimbursetypename !== undefined) {
        this.filterreimbursetypename = params.reimbursetypename
      }
      if (params.paymentstatus !== undefined) {
        this.filterpaymentstatus = params.paymentstatus
      }
    })
  }

  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.fnUserFailedForm();
      }

    });
  }



  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.reimburseform.reset();
      this.fnInitializeFormGroup();

      if (this.reimburseid > 0) {
        this.fngetReimburse();
      }
      this.fngetReimburseType();
      this.fngetEmployee();
      this.fngetExpenseType();
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.reimburseid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    this.isapprovemode = this.loginService.fnCheckUserRoleAction(this.formname, 'APPROVE')
    this.isrejectmode = this.loginService.fnCheckUserRoleAction(this.formname, 'REJECT')
    this.ispaymentmode = this.loginService.fnCheckUserRoleAction(this.formname, 'PAYMENT')
    this.isexpensetypeaddmode= this.loginService.fnCheckUserRoleAction("Expensetype", 'CREATE')


    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }
  fnInitializeFormGroup() {
    this.reimburseform.setValue({
      reimburseid: 0,
      empid: null,
      reimbursetypeid: null,
      amount: null,
      transdt: new Date(),
      descr: '',
      inactive: false,
      isaffectpayroll: false,
      effectivedt: this.loginService.fnLastDate(new Date()),
      expensetypeid: null,
    })
  }
  fngetExpenseType() {
    var data = {
      'expensetypeid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getExpenseType(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.expensetypeColl = res.json().result;
            console.log(this.expensetypeColl)
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  fngetReimburseType() {
    var data = {
      'reimburseid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getReimburseType(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.reimbursetypeColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  fngetEmployee() {
    this.isemploading = true;
    var data = {
      'empid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getEmpListView(data)
      .subscribe(
        (res) => {
          this.isemploading = false;
          if (res.json().status === 200) {
            this.empColl = res.json().result;
            this.fnChangeEmpLookup();
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.isemploading = false;
          this.toastr.error('Error', err);
        })
  }


  //Get 
  fngetReimburse() {
    if (this.showProgress) {
      return;
    }
    var data = {
      'reimburseid': this.reimburseid,
      'companyid': this.loginService.fnGetCompanyId()
    }
    this.appService.fngetReimburse(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.fnHideProgress();

            this.reimburseColl = res.json().result;
            var editdata = this.reimburseColl[0];
            this.reimburseBO = editdata;
            this.fnEditMode(editdata);
          }
          else {
            this.fnHideProgress();

            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {
          this.fnHideProgress();

          this.toastr.error('Error', err);
        })
  }

  fnChangeEmpLookup() {
    var empid = 0;

    empid = this.reimburseform.get("empid").value;

    if (empid > 0) {
      for (let abo of this.empColl) {
        if (abo.empid === empid) {
          this.empBO = abo;
        }
      }

    }
    else {
      this.empBO = {};
    }


  }

  
  fnResetValidation() {
    if (this.loginService.fnCheckFornControlNotfound(this.reimburseform.get('effectivedt'))) {
      this.reimburseform.controls['effectivedt'].setErrors(null);
    }

    if (this.loginService.fnCheckFornControlNotfound(this.reimburseform.get('inactive'))) {
      this.reimburseform.controls['inactive'].setErrors(null);
    }
  }

  fnSetValidation() {
    let _ischeck = false;
    if (this.loginService.fnCompareDateValidation(this.reimburseform.get('effectivedt').value, this.reimburseform.get('transdt').value)) {
      this.reimburseform.controls['effectivedt'].setErrors({ 'notfound': true });
      _ischeck = true;
    }

    return _ischeck;
  }


  //Save Btn Click
  fnSaveBtnClick() {
    try {
      if (this.saveloading) {
        return;
      }

      this.submitted = true;
      this.successfully = false;

      this.fnResetValidation()
      //Validate
      if (this.reimburseform.valid) {

        if (this.fnSetValidation()) {
          return;
        }


        this.saveloading = true;

        //Check
        var data = {
          'reimburseid': this.reimburseid,
          'transdt': this.fnFormatDatetime(this.reimburseform.get('transdt').value),
          'empid': this.reimburseform.get('empid').value,
          'reimbursetypeid': this.reimburseform.get('reimbursetypeid').value,
          'amount': this.reimburseform.get('amount').value,
          'descr': this.reimburseform.get('descr').value,
          'effectivedt': this.fnFormatDatetime(this.reimburseform.get('effectivedt').value),
          'inactive': this.reimburseform.get('inactive').value,
          'isaffectpayroll': this.reimburseform.get('isaffectpayroll').value,
          'expensetypeid': this.reimburseform.get('expensetypeid').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }

        this.appService.fnCheckReimburse(data).subscribe(
          (res) => {
            if (res.json().status === 200) {
              var _checkresponce = res.json().result[0];

              var _checkresult = _checkresponce.checkfield;

              if (_checkresult === 'done') {

                if (this.reimburseform.get('reimburseid').value > 0) {
                  //Update 
                  this.fnSetReimburse(data);
                }
                else {
                  //Insert 
                  this.fnInsertReimburse(data);
                }
              }
              else {
                if (_checkresult === "COMMON") {
                  this.saveloading = false;
                  this.checkfeildmsg = _checkresponce.checkvaluemsg;

                  this.reimburseform.controls['inactive'].setErrors({ 'notfound': true });
                }
              }
            }
            else {
              this.loginService.fnAPIError(res.json())
            }
          },
          (err) => {
            this.toastr.error('Error', err);
          });

      }
    } catch (ex) {
      this.saveloading = false;

      this.fnShowErrorMsg(ex);
    }
  }


  //Insert
  fnInsertReimburse(data) {

    this.appService.fnInsertReimburse(data).subscribe(
      (res) => {
        this.saveloading = false;

        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.fnResetSaveFlag();
            this.toastr.success('', "The new reimburse has been added successfully.Insert Successfully");
            this.fnInsertActivityLog('INSERT', 0, this.fngetDescriptionRefno(data));

            var _result = res.json().result;
            if (_result.length > 0) {
              this.fnEditFormEdit(_result[0].reimburseid);
            }

          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetReimburse(data) {

    this.appService.fnSetReimburse(data).subscribe(
      (res) => {
        this.saveloading = false;

        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.fnResetSaveFlag();
            this.toastr.success('', "The reimburse has been updated successfully.");
            this.fnInsertActivityLog('EDIT', this.reimburseid, this.fngetDescriptionRefno(data));
            this.fnEditFormEdit(this.reimburseid);

          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }

  fnEmployeeSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.empname.toLocaleLowerCase().indexOf(term) > -1 ||
      item.staffcode.toLocaleLowerCase().indexOf(term) > -1;
  }


  //AddReimburseType
  private fnAddReimburseType() {

    const modalRef = this.productFindService.open(AddreimbursetypepopupComponent, { size: <any>'l' });

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fngetReimburseType();

      if (receivedEntry > 0) {
        this.reimburseform.patchValue({ reimbursetypeid: receivedEntry })
      }
    });

  }
  //AddExpenseType
  private fnAddExpenseType() {

    const modalRef = this.productFindService.open(AddexpensetypepopupComponent, { size: <any>'l' });

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fngetExpenseType();

      if (receivedEntry > 0) {
        this.reimburseform.patchValue({ expensetypeid: receivedEntry })
      }
    });

  }
  fnAddPaymentInfo() {

    const modalRef = this.productFindService.open(TranspaymentinfoComponent, { size: <any>'l' });
    modalRef.componentInstance.trid = this.reimburseid;
    modalRef.componentInstance.formname = this.formname;

    modalRef.componentInstance.transdate = this.reimburseBO.transdt;
    modalRef.componentInstance.transpaymodeid = this.reimburseBO.transpaymodeid;
    modalRef.componentInstance.refno = this.reimburseBO.payrefno;
    modalRef.componentInstance.paiddt = this.fnConvertDatetime(this.fnFormatDatetime(this.reimburseBO.paiddt));
    modalRef.componentInstance.paymentinfo = this.reimburseBO.paymentinfo;

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
      if (receivedEntry === "DONE") {
        this.fngetReimburse();
      }


    });
  }
  public fnRemovePayment() {
    try {
      this.confirmationDialogService.confirm('Confirm..', 'Do you  want to Remove Payment?')
        .then((confirmed) => {
          if (confirmed) {
           this.fnSetRemovePayment()
          }
        }
        );
      //.catch(() => );
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  private fnSetRemovePayment() {
    var data = {
      'trxid': this.reimburseid,
      'formname': this.formname,
      'modifiedby': this.loginService.fnGetModUserId(),
    }
    this.appService.fnSetRemovePayment(data)
      .subscribe(
        (res) => {

          if (res.json().status === 200) {
            this.toastr.success('', " The Payment has been Removed successfully.");
            //this.fnInsertActivityLog('DELETE', deptid, reftxt);
            this.fngetReimburse();
          }
          else {
            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fnEditFormEdit(id) {

    this.reimburseid = id;
    this.isaddmode = false;
    this.iseditmode = false;
    this.isdeletemode = false;
    this.isviewmode = true;


    let queryParams = {
      'id': id,
      'status': this.filterstatus,
      'empid': this.filteremployeeid,
      'empname': this.filteremployeename,
      'fromdate': this.fnFormatDatetime(this.filterfromdate),
      'todate': this.fnFormatDatetime(this.filtertodate),
      'reimbursetypeid': this.filterreimbursetypeid,
      'reimbursetypename': this.filterreimbursetypename,
      'paymentstatus': this.filterpaymentstatus,
      
    }


    this.router.navigate([], { relativeTo: this.route, queryParams: queryParams }).then(() => {
      this.ngOnInit();
    });


  }


  //Close
  async fnCloseForm() {
    try {
      if ((this.isaddmode || this.iseditmode) && !this.ismanualclose) {
        var a = await this.loginService.fnConfirmFormLeave();
        if (a === false) {
          return false;
        }
      }

      this.ismanualclose = true;

      if (this.rtnform !== '') {
        this.router.navigate(['/' + this.rtnform]);
      }
      else {
        let navigationExtras: NavigationExtras = {
          queryParams: {
            'status': this.filterstatus,
            'empid': this.filteremployeeid,
            'empname': this.filteremployeename,
            'fromdate': this.fnFormatDatetime(this.filterfromdate),
            'todate': this.fnFormatDatetime(this.filtertodate),
            'reimbursetypeid': this.filterreimbursetypeid,
            'reimbursetypename': this.filterreimbursetypename,
            'paymentstatus': this.filterpaymentstatus,

          }
        }

        this.router.navigate(['/Reimburse'], navigationExtras);
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  private fnEditMode(deptBO) {
    deptBO.transdt = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.transdt));
    deptBO.effectivedt = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.effectivedt));

    this.reimburseform.setValue({
      reimburseid: deptBO.reimburseid,
      empid: deptBO.empid,
      reimbursetypeid: deptBO.reimbursetypeid,
      amount: deptBO.amount,
      transdt: deptBO.transdt,
      descr: deptBO.descr,
      effectivedt: deptBO.effectivedt,
      inactive: deptBO.inactive,
      isaffectpayroll: deptBO.isaffectpayroll,
      expensetypeid: deptBO.expensetypeid,
    });

    this.formmode = "Edit";

    this.isaddmode = false;
    this.iseditmode = false;
    this.isdeletemode = false;
    this.isviewmode = true;

    this.fnVisibilityApproveStatus();
    this.fnChangeEmpLookup();
    this.fnGetAttachmentCount();
  }


  //Approvals
  fnApproveBtnClick(type) {


    this.approvebar.formtype = type;
    this.approvebar.fnInitializeFormGroup();
    this.approvebar.fnGetApproveForms();

    this.isshowapproval = !this.isshowapproval

  }

  fnCloseApproveBtnClick(data) {
    this.isshowapproval = !this.isshowapproval

    if (data === 'DONE') {
      this.fngetReimburse();
    }

  }

  fnVisibilityApproveStatus() {

    this.isapprove = false;
    this.isreject = false;

    if (this.reimburseBO.approvedstatus !== '') {
      if (this.reimburseBO.approvedstatus === 'Approve') {
        this.isreject = true;
      }
      else if (this.reimburseBO.approvedstatus === 'Reject') {
        this.isapprove = true;
      }
    }
    else {
      this.isapprove = true;
      this.isreject = true;
    }

  }

  fnEditBtnClick() {
    this.iseditmode = true;

    this.isviewmode = false;
  }
  //#Attachment
  fnAttachmentBtnClick() {

    const modalRef = this.productFindService.open(AttachmentComponent, { size: <any>'xxl' });
    modalRef.componentInstance.formname = this.formname;
    modalRef.componentInstance.trxid = this.reimburseid;
    modalRef.componentInstance.formmode = "EDIT";
    modalRef.componentInstance.fnGetAttachment();


    modalRef.result.then(() => {
      this.fnGetAttachmentCount()
    }, () => {
      this.fnGetAttachmentCount()
    })


    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
      if (receivedEntry === 'DONE') {
        this.fngetReimburse();
      }
    });


  }


  fnAttachmentSave(tid) {


  }

  fnSetAttachmentCount(data) {

    this.attachmentcount = data;
  }





  //Approvals POP
  fnShowApprovalPop(stauts) {

    const modalRef = this.productFindService.open(ApprovepopComponent, { size: <any>'l' });
    modalRef.componentInstance.formmode = stauts;
    modalRef.componentInstance.formname = this.formname;
    modalRef.componentInstance.formid = this.reimburseid;

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      if (receivedEntry === 'DONE') {
        this.fngetReimburse();
      }


    });
  }


  //Attachment
  fnGetAttachmentCount() {
    if (this.reimburseid > 0) {
      var data = {
        'trxid': this.reimburseid,
        'trxtype': this.formname,
      }


      this.appService.fngetAttachmentCountDetails(data).subscribe(
        (res) => {
          if (res.json().status === 200) {
            var result = res.json().result;
            if (result.length > 0) {
              this.attachmentcount = result[0].attachmentcount
            }
          }
          else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        });
    }

  }

  fnAddActivity(){

    const modalRef = this.productFindService.open(ActivitypopupComponent, { size: <any>'l' });
    modalRef.componentInstance.formname = this.formname;
    modalRef.componentInstance.trxid = this.reimburseid;

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {      

     
    });

  }
  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }

  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }
  fngetDescriptionRefno(data) {
    var rtnstr = "";
    try {
      if (data.transdt) {
        rtnstr = rtnstr + data.transdt;
      }

      if (data.empid) {
        rtnstr = rtnstr + " - " + data.empid;
      }

      if (data.empname) {
        rtnstr = rtnstr + " - " + data.empname;
      }
    } catch {

    }
    return rtnstr;
  }
  @HostListener('window:beforeunload')
  canDeactivate(): any {
    if (this.isaddmode || this.iseditmode) {
      return false;
    }
    else {
      return true;
    }
  }

  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc, companyid: this.loginService.fnGetCompanyId(),
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }
  fnResetSaveFlag() {
    this.submitted = false;
    this.successfully = false;
  }
  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }
  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }






}
